(function() {
  'use strict';

  var scope = document.querySelector('.cd-butyl-pdp');
  if (!scope) return;

  /* ============================================
     VARIANT DATA
     ============================================ */
  var variantDataEl = document.getElementById('cd-variant-data');
  var variants = [];
  if (variantDataEl) {
    try { variants = JSON.parse(variantDataEl.textContent); } catch(e) { variants = []; }
  }

  /* ============================================
     CART REFRESH — Fetch sections + update drawer + open
     ============================================ */
  function refreshCart() {
    fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        /* Update cart icon bubble */
        var iconEl = document.getElementById('cart-icon-bubble');
        if (iconEl && sections['cart-icon-bubble']) {
          var t1 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          var n1 = t1.querySelector('.shopify-section');
          if (n1) iconEl.innerHTML = n1.innerHTML;
        }

        /* Update cart drawer content */
        var drawerEl = document.getElementById('CartDrawer');
        if (drawerEl && sections['cart-drawer']) {
          var t2 = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var n2 = t2.querySelector('#CartDrawer');
          if (n2) drawerEl.innerHTML = n2.innerHTML;
        }

        /* Remove is-empty from all relevant elements */
        var cd = document.querySelector('cart-drawer');
        if (cd) {
          cd.classList.remove('is-empty');
          var di = cd.querySelector('cart-drawer-items');
          if (di) di.classList.remove('is-empty');
          var inner = cd.querySelector('.drawer__inner');
          if (inner) inner.classList.remove('is-empty');

          /* Re-bind overlay close */
          var ov = cd.querySelector('#CartDrawer-Overlay');
          if (ov) ov.addEventListener('click', function() {
            cd.classList.remove('active');
            document.body.classList.remove('overflow-hidden');
          });

          /* Open drawer */
          cd.classList.add('animate', 'active');
          document.body.classList.add('overflow-hidden');
        }
      }).catch(function() {});
  }

  /* ============================================
     FAQ ACCORDION (full-page FAQ)
     ============================================ */
  scope.querySelectorAll('.faq-question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.parentElement;
      var isOpen = item.classList.contains('open');
      scope.querySelectorAll('.faq-item').forEach(function(i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  /* ============================================
     GALLERY THUMBNAIL SWITCHING
     ============================================ */
  var reviewCard = scope.querySelector('#galleryReviewCard');
  var mainImg = scope.querySelector('.gallery-main img');

  scope.querySelectorAll('.gallery-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      scope.querySelectorAll('.gallery-thumb').forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');

      if (thumb.dataset.review) {
        if (mainImg) mainImg.style.opacity = '0';
        if (reviewCard) reviewCard.style.display = 'flex';
        return;
      }

      if (reviewCard) reviewCard.style.display = 'none';
      if (mainImg) mainImg.style.opacity = '1';
      var thumbImg = thumb.querySelector('img');
      if (thumbImg && mainImg) {
        var largeSrc = thumbImg.src;
        if (largeSrc.indexOf('width=') !== -1) {
          largeSrc = largeSrc.replace(/width=\d+/, 'width=1200');
        }
        mainImg.src = largeSrc;
      }
    });
  });

  /* ============================================
     BUY BOX FAQ ACCORDION
     ============================================ */
  scope.querySelectorAll('.buybox-faq-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.parentElement;
      var isOpen = item.classList.contains('open');
      scope.querySelectorAll('.buybox-faq-item').forEach(function(i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  /* ============================================
     FREQUENTLY BOUGHT TOGETHER
     ============================================ */
  function getMainProductPrice() {
    var priceEl = scope.querySelector('.current-price');
    if (!priceEl) return 0;
    return parseFloat(priceEl.textContent.replace(/[^0-9.]/g, '')) || 0;
  }

  function updateFbtTotal() {
    var total = getMainProductPrice();
    scope.querySelectorAll('.fbt-item').forEach(function(item) {
      if (item.querySelector('.fbt-item-check.checked')) {
        total += parseFloat(item.dataset.price) || 0;
      }
    });
    var totalEl = scope.querySelector('#fbt-total-price');
    if (totalEl) totalEl.textContent = '$' + total.toFixed(2);
  }

  scope.querySelectorAll('.fbt-item-check').forEach(function(el) {
    el.addEventListener('click', function() {
      el.classList.toggle('checked');
      updateFbtTotal();
    });
  });

  /* Calculate initial FBT total on page load */
  updateFbtTotal();

  /* FBT Add All to Cart */
  var fbtAddBtn = scope.querySelector('.fbt-add-btn');
  if (fbtAddBtn) {
    fbtAddBtn.addEventListener('click', function() {
      var items = [];
      /* Add the main product */
      var variantInput = scope.querySelector('[name="id"]');
      if (variantInput) {
        var qtyInput = scope.querySelector('.qty-input');
        items.push({
          id: parseInt(variantInput.value),
          quantity: parseInt(qtyInput ? qtyInput.value : 1) || 1
        });
      }
      /* Add checked FBT products */
      scope.querySelectorAll('.fbt-item').forEach(function(item) {
        if (item.querySelector('.fbt-item-check.checked') && item.dataset.variantId) {
          items.push({
            id: parseInt(item.dataset.variantId),
            quantity: 1
          });
        }
      });

      if (items.length === 0) return;

      fbtAddBtn.disabled = true;
      fbtAddBtn.textContent = 'Adding...';

      /* Step 1: Apply discount FIRST so it's in session when cart-drawer renders */
      var qty = parseInt(scope.querySelector('.qty-input').value) || 1;
      var discountUrl = (activeDiscountCode && qty >= 3)
        ? '/discount/' + activeDiscountCode
        : '/discount/CLEAR';

      fetch(discountUrl, { redirect: 'manual' }).catch(function() {}).then(function() {
        /* Step 2: Add items to cart AFTER discount is set */
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function(res) { return res.json(); })
      .then(function() {
        fbtAddBtn.disabled = false;
        fbtAddBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg> Added!';
        setTimeout(function() {
          fbtAddBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg> Add All to Cart';
        }, 2000);
        refreshCart();
      })
      .catch(function() {
        fbtAddBtn.disabled = false;
        fbtAddBtn.textContent = 'Add All to Cart';
      });
    });
  }

  /* ============================================
     VARIANT DROPDOWN
     ============================================ */
  var variantSelect = scope.querySelector('#variantSelect');
  if (variantSelect) {
    variantSelect.addEventListener('change', function() {
      var opt = this.options[this.selectedIndex];
      var variantId = opt.value;
      var price = opt.dataset.price;
      var desc = opt.dataset.desc;

      /* Update hidden variant input */
      var hiddenInput = scope.querySelector('[name="id"]');
      if (hiddenInput && variantId) hiddenInput.value = variantId;

      /* Update variant detail row with coverage description */
      var useEl = scope.querySelector('.variant-use');
      if (useEl) useEl.textContent = desc || '';

      /* Update sticky ATC name */
      var stickyName = scope.querySelector('.sticky-atc-name');
      if (stickyName) stickyName.textContent = 'Butyl Tape \u2014 ' + opt.dataset.sizeLabel;

      /* Re-run volume tier calc — updates all price displays with discount applied */
      var qtyVal = parseInt(scope.querySelector('.qty-input').value) || 1;
      if (window.cdUpdateVolumeTier) window.cdUpdateVolumeTier(qtyVal);
    });
    /* Set initial description on page load */
    var initOpt = variantSelect.options[variantSelect.selectedIndex];
    var initUse = scope.querySelector('.variant-use');
    if (initOpt && initUse) initUse.textContent = initOpt.dataset.desc || '';
  }

  /* ============================================
     VOLUME PRICING TIERS + DISCOUNT CODE AUTO-APPLY
     ============================================ */
  var activeDiscountCode = '';

  (function() {
    var tiersContainer = scope.querySelector('.volume-tiers');
    var tierEls = scope.querySelectorAll('.volume-tier');
    var qtyInput = scope.querySelector('.qty-input');
    var nudge = scope.querySelector('#volumeNudge');
    var nudgeText = scope.querySelector('#nudgeText');
    if (!qtyInput || tierEls.length === 0) return;

    /* Read tier config from data attribute */
    var tierRanges = [];
    try { tierRanges = JSON.parse(tiersContainer.dataset.tiers); } catch(e) {}
    if (!tierRanges.length) {
      tierRanges = [
        { min: 1, max: 2, pct: 0, code: '' },
        { min: 3, max: 5, pct: 5, code: 'BUT5BULK' },
        { min: 6, max: 9, pct: 8, code: 'BUT8BULK' },
        { min: 10, max: 999, pct: 12, code: 'BUT12BULK' }
      ];
    }

    function getBasePrice() {
      var sel = scope.querySelector('#variantSelect');
      if (sel) return parseFloat(sel.options[sel.selectedIndex].dataset.price) || 0;
      var priceEl = scope.querySelector('.current-price');
      if (priceEl) return parseFloat(priceEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      return 0;
    }

    function getActiveTier(qty) {
      for (var i = 0; i < tierRanges.length; i++) {
        if (qty >= tierRanges[i].min && qty <= tierRanges[i].max) return i;
      }
      return tierRanges.length - 1;
    }

    function updatePriceDisplays(basePrice, pct, qty) {
      var unitPrice = pct > 0 ? (basePrice * (1 - pct / 100)) : basePrice;
      var total = unitPrice * qty;
      var totalStr = total.toFixed(2);
      var unitStr = unitPrice.toFixed(2);

      /* Main price = TOTAL */
      var priceEl = scope.querySelector('.current-price');
      if (priceEl) priceEl.textContent = '$' + totalStr;
      /* Mobile price = TOTAL */
      var mobilePriceEl = scope.querySelector('.mobile-price');
      if (mobilePriceEl) mobilePriceEl.textContent = '$' + totalStr;
      /* ATC button price = TOTAL */
      var atcBtn = scope.querySelector('.add-to-cart-btn');
      if (atcBtn) atcBtn.innerHTML = atcBtn.innerHTML.replace(/\$[\d,.]+/, '$' + totalStr);
      /* Sticky ATC price = TOTAL */
      var stickyPrice = document.querySelector('.sticky-atc-price');
      if (stickyPrice) stickyPrice.textContent = '$' + totalStr;
      /* Section nav price = TOTAL */
      var navPrice = scope.querySelector('.section-nav-price');
      if (navPrice) navPrice.textContent = '$' + totalStr;

      /* Per-unit price line under main price */
      var perUnitEl = scope.querySelector('.price-per-unit');
      if (!perUnitEl) {
        perUnitEl = document.createElement('div');
        perUnitEl.className = 'price-per-unit';
        var priceRow = scope.querySelector('.price-row');
        if (priceRow) priceRow.parentNode.insertBefore(perUnitEl, priceRow.nextSibling);
      }
      if (perUnitEl) {
        if (qty > 1) {
          perUnitEl.textContent = '$' + unitStr + '/box \u00d7 ' + qty;
          perUnitEl.style.display = '';
        } else {
          perUnitEl.style.display = 'none';
        }
      }

      /* Show compare-at TOTAL when discounted */
      var compareEl = scope.querySelector('.compare-price');
      if (compareEl) {
        if (pct > 0) {
          compareEl.textContent = '$' + (basePrice * qty).toFixed(2);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      /* Show savings badge */
      var saveBadge = scope.querySelector('.discount-save-badge');
      if (pct > 0) {
        var totalSaved = ((basePrice - unitPrice) * qty).toFixed(2);
        if (!saveBadge) {
          saveBadge = document.createElement('span');
          saveBadge.className = 'discount-save-badge';
          var priceRow2 = scope.querySelector('.price-row');
          if (priceRow2) priceRow2.appendChild(saveBadge);
        }
        saveBadge.textContent = 'Save $' + totalSaved + ' (' + pct + '% off)';
        saveBadge.style.display = '';
      } else if (saveBadge) {
        saveBadge.style.display = 'none';
      }
    }

    function updateVolumeTier(qty) {
      var idx = getActiveTier(qty);
      var tier = tierRanges[idx];
      var basePrice = getBasePrice();
      activeDiscountCode = tier.code || '';

      /* Highlight active tier */
      tierEls.forEach(function(t, i) { t.classList.toggle('active', i === idx); });

      /* Update price displays with discount — total = unit × qty */
      updatePriceDisplays(basePrice, tier.pct, qty);

      /* Update FBT total if present */
      updateFbtTotal();

      /* Nudge messaging */
      if (!nudge || !nudgeText) return;
      var nextTier = tierRanges[idx + 1];
      if (nextTier) {
        var needed = nextTier.min - qty;
        var extraSave = (basePrice * nextTier.pct / 100 - basePrice * tier.pct / 100).toFixed(2);
        nudgeText.textContent = 'Add ' + needed + ' more box' + (needed > 1 ? 'es' : '') + ' to unlock ' + nextTier.pct + '% off \u2014 save $' + extraSave + ' more per box!';
        nudge.style.display = 'flex';
      } else {
        nudgeText.textContent = "You're getting the maximum " + tier.pct + '% bulk discount!';
        nudge.style.display = 'flex';
      }
    }

    /* Expose for variant change handler */
    window.cdUpdateVolumeTier = updateVolumeTier;

    /* Quantity +/- buttons */
    var qtyBtns = scope.querySelectorAll('.qty-btn');
    if (qtyBtns.length >= 2) {
      qtyBtns[0].addEventListener('click', function() {
        var val = Math.max(1, (parseInt(qtyInput.value) || 1) - 1);
        qtyInput.value = val;
        updateVolumeTier(val);
      });
      qtyBtns[1].addEventListener('click', function() {
        var val = (parseInt(qtyInput.value) || 1) + 1;
        qtyInput.value = val;
        updateVolumeTier(val);
      });
    }

    qtyInput.addEventListener('change', function() {
      var val = Math.max(1, parseInt(qtyInput.value) || 1);
      qtyInput.value = val;
      updateVolumeTier(val);
    });

    /* Click tier to set quantity */
    tierEls.forEach(function(tier, i) {
      tier.addEventListener('click', function() {
        qtyInput.value = tierRanges[i].min;
        updateVolumeTier(tierRanges[i].min);
      });
    });

    updateVolumeTier(parseInt(qtyInput.value) || 1);
  })();

  /* ============================================
     ADD TO CART (AJAX)
     ============================================ */
  var atcForm = scope.querySelector('#cd-product-form');
  if (atcForm) {
    atcForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var variantInput = atcForm.querySelector('[name="id"]');
      var qtyInput = scope.querySelector('.qty-input');
      if (!variantInput) return;

      var atcBtn = scope.querySelector('.add-to-cart-btn');
      var originalHtml = atcBtn ? atcBtn.innerHTML : '';
      if (atcBtn) {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Adding...';
      }

      /* Step 1: Apply or clear discount code FIRST (awaited) */
      var discountUrl = activeDiscountCode
        ? '/discount/' + activeDiscountCode
        : '/discount/CLEAR';

      fetch(discountUrl, { redirect: 'manual' }).catch(function() {}).then(function() {
        /* Step 2: Add to cart AFTER discount is set in session */
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: parseInt(variantInput.value),
            quantity: parseInt(qtyInput ? qtyInput.value : 1) || 1
          })
        });
      })
      .then(function(res) { return res.json(); })
      .then(function() {
        if (atcBtn) {
          atcBtn.disabled = false;
          atcBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg> Added!';
          setTimeout(function() { atcBtn.innerHTML = originalHtml; }, 2000);
        }
        refreshCart();
      })
      .catch(function() {
        if (atcBtn) {
          atcBtn.disabled = false;
          atcBtn.innerHTML = originalHtml;
        }
      });
    });
  }

  /* Sticky ATC button also submits */
  var stickyBtn = scope.querySelector('.sticky-atc-btn');
  if (stickyBtn && atcForm) {
    stickyBtn.addEventListener('click', function() {
      atcForm.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  }

  /* ============================================
     SECTION NAV (Sticky)
     ============================================ */
  (function() {
    var sectionNav = scope.querySelector('.section-nav');
    var productHero = scope.querySelector('.product-hero');
    if (!sectionNav || !productHero) return;

    var heroObserver = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting) {
        sectionNav.classList.remove('visible');
      } else {
        sectionNav.classList.add('visible');
      }
    }, { threshold: 0 });
    heroObserver.observe(productHero);

    /* Active link highlighting */
    var navLinks = sectionNav.querySelectorAll('.section-nav-links a');
    var sectionIds = [];
    navLinks.forEach(function(a) { sectionIds.push(a.getAttribute('href').slice(1)); });
    var sections = sectionIds.map(function(id) { return document.getElementById(id); }).filter(Boolean);

    var sectionObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          navLinks.forEach(function(a) { a.classList.remove('active'); });
          var activeLink = sectionNav.querySelector('a[href="#' + entry.target.id + '"]');
          if (activeLink) activeLink.classList.add('active');
        }
      });
    }, { rootMargin: '-60px 0px -60% 0px', threshold: 0 });

    sections.forEach(function(s) { sectionObserver.observe(s); });

    /* Smooth scroll with offset */
    navLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var target = document.getElementById(link.getAttribute('href').slice(1));
        if (target) {
          var offset = 60;
          var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });

    /* Section nav ATC button scrolls to top */
    var navBtn = sectionNav.querySelector('.section-nav-btn');
    if (navBtn) {
      navBtn.addEventListener('click', function() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  })();

})();
